import React from 'react'

// Allow-list of URL schemes safe to use as an anchor `href`. Anything else
// (`javascript:`, `data:`, `vbscript:`, `file:`, …) returns null so the caller
// can render plain text instead of a live link — defense-in-depth against
// stored URLs that bypassed server-side scrubbing.
const ALLOWED_HREF_SCHEMES = ['http:', 'https:', 'mailto:', 'tel:']

// Convert an `internal://…` entity URL into an admin route. External URLs are
// returned only when their scheme is in the allow-list above; otherwise null.
const entityURL = (externalUrl) => {
  let url
  try {
    url = new URL(externalUrl)
  } catch {
    return null
  }
  if (url.protocol === 'internal:') {
    const [entityName, entityId] = (url.hostname ? url.hostname + url.pathname : url.pathname).replace(/^[^\w]+/, '').split('/')
    switch (entityName) {
      case 'campaign':
        return `/admin/campaigns/${entityId}/overview`
      case 'flow':
        return `/admin/flows/${entityId}/overview`
      default:
        return `/admin/${entityName}/${entityId}`
    }
  }
  if (ALLOWED_HREF_SCHEMES.includes(url.protocol)) return externalUrl
  return null
}

// Returns an array of React children (string segments + <a> nodes) for an activity body,
// replacing each occurrence of a linkable entity's name with an anchor to its URL.
// Returning React nodes — rather than an HTML string rendered via dangerouslySetInnerHTML —
// means string segments go through React's auto-escaping, so any HTML in `body` renders
// as literal text.
const renderBodyWithLinks = (body, linkableEntities = []) => {
  if (body == null) return []
  let nodes = [body]
  let keyCounter = 0

  linkableEntities
    .filter((entity) => entity && entity.externalUrl && entity.name)
    .forEach((entity) => {
      const { name } = entity
      const href = entityURL(entity.externalUrl)
      nodes = nodes.flatMap((node) => {
        if (typeof node !== 'string' || !node.includes(name)) return [node]
        const parts = node.split(name)
        const out = []
        parts.forEach((part, i) => {
          if (i > 0) {
            if (href) {
              out.push(
                <a
                  key={`entity-link-${keyCounter++}`}
                  href={href}
                  style={{ fontWeight: 600, fontSize: 14 }}
                >
                  {name}
                </a>
              )
            } else {
              out.push(name)
            }
          }
          if (part !== '') out.push(part)
        })
        return out
      })
    })

  return nodes
}

export { entityURL }
export default renderBodyWithLinks
